import React, { Component } from "react"
import { HexColorPicker } from "react-colorful"
import { Button, FormControl, Modal, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import store from "src/store/store"
import DynamicFormTypes from "../../Types/DynamicFormsTypes"
import DynamicForm from "../../DynamicForm/DynamicForm"
import stateMutator from "../StateMutator"
import FieldTypes from "../../Types/FieldTypes"
import paletteEngine from "../paletteEngine"
import "./EditReduxColor.css"

interface Props {
    manageParentState: Function
    palette: Array<DynamicFormPaletteTypes>
    form: DynamicFormTypes | null
    template: Array<Array<FieldTypes>> | [[]]
    hints: boolean
}

interface State {
    paletteDex: number
    paletteItems: Array<DynamicFormPaletteTypes>
    paletteItemsCopy: Array<DynamicFormPaletteTypes>
    input: string
    busy: boolean
}

class EditReduxColor extends Component<Props, State>{

    colorChangeTimeout: any
    typingTimeout: any = 0

    state = {
        paletteDex: 0,
        paletteItems: JSON.parse(JSON.stringify(this.props.palette)),
        paletteItemsCopy: JSON.parse(JSON.stringify(this.props.palette)),
        input: "",
        busy: false
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    /* Filtering the palette items based on the input. */
    filterPaletteItems = (input: string, palette: Array<DynamicFormPaletteTypes>) => {
        let temp = []
        for (let i = 0; i < palette.length; i++) {
            let str = palette[i].name
            //@ts-ignore
            str = str.toLowerCase()
            if (str.includes(input)) {
                temp.push(palette[i])
            }
        }
        this.manageState([{ key: "paletteItems", value: temp }, { key: "busy", value: false }])
    }

    /* A debounce function. It is used to prevent the filterPaletteItems function from being called too often. */
    debounce = (event: { target: { value: string } }) => {
        const input = event.target.value.toLowerCase()
        this.manageState([{ key: "input", value: input }, { key: "busy", value: true }, { key: "paletteDex", value: 0 }])
        if (this.typingTimeout) {
            clearTimeout(this.typingTimeout);
        }
        this.typingTimeout = setTimeout(() => {
            if (input.length > 0) {
                this.filterPaletteItems(input, this.state.paletteItemsCopy)
            } else {
                this.manageState([{ key: "busy", value: false }, { key: "paletteItems", value: this.state.paletteItemsCopy }])
            }
        }, 500)
    }

    /* Getting the index of the palette item in the palette array. */
    getPaletteDex = (paletteItem: DynamicFormPaletteTypes) => {
        const items = this.props.palette
        for (let i = 0; i < items.length; i++) {
            if (paletteItem.key === items[i].key) {
                return i
            }
        }
        return 0
    }

    /* A function that is called when the color picker is changed. It is used to update the color in the
    redux store. */
    handleColorChange = (event: string, dispatchKey: string) => {
        clearTimeout(this.colorChangeTimeout)
        this.colorChangeTimeout = setTimeout(() => {
            store.dispatch({ type: dispatchKey, payload: event })
        }, 100)
    }

    render() {

        const props = this.props
        const state = this.state
        const palette = props.palette
        const paletteItem = palette[state.paletteDex]
        const paletteItems = state.paletteItems

        const EditReduxColorTooltip = (text: string) => (
            // <Tooltip id={`dynamic-form-tool-tip-hide-${!props.hints}`}>
            <Tooltip id={`dynamic-form-tool-tip-hide-false`}>
                {text}
            </Tooltip>
        )

        // console.log("EditReduxColor palette", props)

        return (
            <div className="EditReduxColor">
                <Modal
                    id="edit-redux-color-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size="xl"
                >
                    <Modal.Body>
                        <div className="EditReduxColorModalBody">
                            <div className="EditReduxColorModalBodyLeft" style={{ backgroundColor: `${paletteEngine.getPaletteColor("formBackgroundColor")}` }}>
                                <DynamicForm
                                    //@ts-ignore
                                    form={props.form}
                                    palette={props.palette}
                                    addOrRemoveColumn={() => null}
                                    submit={() => null}
                                />
                            </div>
                            <div className="EditReduxColorModalBodyRight">
                                <div className="EditReduxColorModalBodyRightColorPicker">
                                    <HexColorPicker color={paletteItem ? paletteItem.hexCode : "#00000030"} onChange={paletteItem ? (event) => this.handleColorChange(event, paletteItem.dispatchKey) : () => null} />
                                </div>
                                <div className="EditReduxColorModalBodyRightSearchPaletteItems">
                                    <div className="EditReduxColorModalBodyRightSearchPaletteItemsLeft">
                                        <FormControl
                                            onChange={this.debounce}
                                            placeholder={"Search palette items"}
                                            value={this.state.input || ""}
                                            type="text"
                                        />
                                    </div>
                                    {state.busy && <div className="EditReduxColorModalBodyRightSearchPaletteItemsRight">
                                        <Spinner id="search-dynamic-form-palette-spinner" animation="border" />
                                    </div>}
                                </div>
                                <div className="EditReduxColorModalBodyRightPaletteItemsList">
                                    {paletteItems.map((item: DynamicFormPaletteTypes, i: number) =>
                                        <div className={`EditReduxColorModalBodyRightPaletteItemsListItem ${state.paletteDex === this.getPaletteDex(item) ? "EditReduxColorModalBodyRightPaletteItemsListItemChecked" : "EditReduxColorModalBodyRightPaletteItemsListItemUnchecked"}`}
                                            key={i} onClick={() => this.manageState([{ key: "paletteDex", value: this.getPaletteDex(item) }])}
                                        >
                                            <div className="EditReduxColorModalBodyRightPaletteItemsListItemLeft">
                                                <div className="EditReduxColorModalBodyRightPaletteItemsListItemColorMarker" style={{ backgroundColor: `${this.props.palette[this.getPaletteDex(item)].hexCode}` }}></div>
                                                <p>{item.name}</p>
                                            </div>
                                            <div className="EditReduxColorModalBodyRightPaletteItemsListItemRight">
                                                <FormControl
                                                    onChange={(e) => this.handleColorChange(e.target.value, paletteItem.dispatchKey)}
                                                    placeholder={this.props.palette[this.getPaletteDex(item)].hexCode}
                                                    value={this.props.palette[this.getPaletteDex(item)].hexCode}
                                                    type="text"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="EditReduxColorModalFooter">
                            <Button variant="secondary" onClick={() => props.manageParentState([{ key: "editPalette" }])}>Back</Button>
                            <OverlayTrigger placement="left" overlay={EditReduxColorTooltip("Reset the form palette")}>
                                <span className="material-icons" onClick={() => store.dispatch({ type: "RESET_DYNAMIC_FORM_PALETTE", payload: null })}>restart_alt</span>
                            </OverlayTrigger>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default EditReduxColor